module.exports = {"361029100":"孝岗镇","361029101":"小璜镇","361029102":"圩上桥镇","361029103":"马圩镇","361029104":"詹圩镇","361029105":"岗上积镇","361029106":"杨桥殿镇","361029107":"黎圩镇","361029108":"王桥镇","361029200":"珀玕乡","361029201":"邓家乡","361029202":"虎圩乡","361029203":"瑶圩乡","361029400":"红星垦殖场","361029401":"红光垦殖场","361029402":"红亮垦殖场","361029403":"甘坑生态林场","361029404":"江西铜业集团公司东同矿业有限责任公司","361029405":"江西磷肥厂","361029406":"东乡县经济开发区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/361029.json
// module id = 1451
// module chunks = 0